import { createTheme, ThemeProvider } from "@mui/material";
export const TrainTheme = createTheme({
  palette: {
    primary: {
      light: "#7986cb",
      main: "#0046A5",
      dark: "#303f9f",
      contrastText: "#fff",
      contactHeading: "#00204c",
      surchargeHeading: "#00204c",
    },
    secondary: {
      light: "#ff4081",
      main: "#f50057",
      dark: "#c51162",
      contrastText: "#fff",
    },
    error: {
      main: "#9D0009",
    },
  },
});
export const TrainThemeProvider = (props) => {
  return <ThemeProvider theme={TrainTheme}>{props.children}</ThemeProvider>;
};
